import React from 'react';
import { Modal } from 'react-bootstrap';

// Asked once a style has been picked to duplicate from: the tasks always come across, the dates
// only if the planner wants them.
const DuplicateTnaConfirmModal = ({ plan, loading, onCancel, onConfirm }) => {
	const styleLabel = plan?.styleRefNo || plan?.styleName || 'the selected style';
	const orderLabel = [plan?.orderName, plan?.orderRefNo && `(${plan.orderRefNo})`]
		.filter(Boolean)
		.join(' ');

	return (
		<Modal show={!!plan} onHide={onCancel} centered>
			<div className="common-popup shadow-24dp">
				<Modal.Header closeButton>
					<h3 className="semibold-16 mb-0">Duplicate TNA</h3>
				</Modal.Header>
				<Modal.Body>
					<div className="common-popup-body">
						<p className="regular-14 gray_dark_01 mb-2">
							Copying the TNA of <strong>{styleLabel}</strong>
							{orderLabel ? ` from ${orderLabel}` : ''} onto this style.
						</p>
						<p className="regular-14 gray_dark_02 mb-0">
							Do you want to bring its tasks and dates, or only its tasks?
						</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onCancel}>
							Cancel
						</button>
						<button
							disabled={loading}
							className="button gray-outline size32 ml-2"
							onClick={() => onConfirm(false)}
						>
							Only task
						</button>
						<button
							disabled={loading}
							className="button size32 ml-2"
							onClick={() => onConfirm(true)}
						>
							Task &amp; date
						</button>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default DuplicateTnaConfirmModal;
